import { render, staticRenderFns } from "./Unsplash.vue?vue&type=template&id=2af2b109&scoped=true"
import script from "./Unsplash.vue?vue&type=script&lang=js"
export * from "./Unsplash.vue?vue&type=script&lang=js"
import style0 from "./Unsplash.vue?vue&type=style&index=0&id=2af2b109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af2b109",
  null
  
)

export default component.exports